import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { Col } from 'react-bootstrap';
import FeatureIcon1 from '../icons/feature1-icon';
import CountTo from 'react-count-to';

class FeatureCounterItem extends React.Component {

    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : ['feature'],
        };
        this.headerVisible = this.headerVisible.bind(this);
        this.isVisible = false;
    }    

    headerVisible(isVisible) {
        if (isVisible) {
            this.isVisible = true;
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 200;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeInLeft');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes});
                }.bind(this), timeDelay);
            }
        }
    };

    render () {
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible } >
                <Col className={this.state.animationClasses.join(' ')} style={ { opacity : 0 } } md={4} sm={6}>
                    <div className="feature-center" >
                        <FeatureIcon1 iconName={ this.props.value.icon }/>
                        <span id="value-random" >
                            {this.isVisible &&
                                <CountTo to={ Number(this.props.value.valueRandom) } speed={4000} delay={10}/>
                            }
                        </span>
                        <span className="counter-label">{ this.props.translate(this.props.value.valueRandomLabel) }</span>
                    </div>
                </Col>
            </VisibilitySensor>
        );
    };
};

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(FeatureCounterItem);




// WEBPACK FOOTER //
// ./src/components/features/featureCounter-item.jsx